import type FamilyPortalAPIClient from '../../auth/FamilyPortalAPIClient'

export type SupportRequestSubject =
  | 'help_with_my_account'
  | 'cancel_a_test'
  | 'questions_about_consent'
  | 'request_a_copy_of_my_report'
  | 'where_are_my_results'
  | 'something_else'

export type SupportRequestPayload = {
  subject: SupportRequestSubject
  description: string
}

export type SupportRequestResult = {
  submitted: boolean
  contactEmail?: string | null
  contactPhone?: string | null
}

const SUPPORT_REQUEST_PATH = '/support/request'

export async function submitSupportRequest(
  client: FamilyPortalAPIClient,
  payload: SupportRequestPayload
): Promise<SupportRequestResult> {
  const response = await client.post(SUPPORT_REQUEST_PATH, payload)

  if (!response.ok) {
    const detail = await response
      .json()
      .then((body: { detail?: unknown }) => (typeof body?.detail === 'string' ? body.detail : null))
      .catch(() => null)
    throw new Error(detail ?? `POST ${SUPPORT_REQUEST_PATH} failed with status ${response.status}`)
  }

  const body = await response.json().catch(() => null)
  if (!isSubmittedSupportRequestResult(body)) {
    throw new Error(`POST ${SUPPORT_REQUEST_PATH} did not confirm submission`)
  }

  return body
}

function isSubmittedSupportRequestResult(value: unknown): value is SupportRequestResult {
  return typeof value === 'object' && value !== null && (value as { submitted?: unknown }).submitted === true
}
